<div class="row justify-content-center">
    <div class="col-auto w-50">
        <table class="table table-responsive">
            <table class="table table-striped table-responsive-md btn-table">
                <thead>
                    <tr>
                        <th *ngFor="let head of headElements" scope="col">{{head}} </th>
                    </tr>
                </thead>
                <tbody>
                    <tr mdbTableCol *ngFor="let car of cars">
                        <td>{{car.name}}</td>
                        <td>{{car.brand}}</td>
                        <td><button mdbBtn color="danger" size="sm" mdbWavesEffect type="button" class="m-0" (click)="deleteCar(car)">Delete car</button></td>
                    </tr>
                </tbody>
            </table>
        </table>
    </div>
</div>